export function programChildHighlight() {
    const currentUrl = window.location.href;
    const navLinks = document.querySelectorAll('.fndry-nav-link');

    navLinks.forEach(link => {
        const href = link.getAttribute('href');

        const isProgram = href.includes('/programs/') && currentUrl.startsWith(href);
        const isBlog = href.includes('/blog') && currentUrl.startsWith(href);
        const isAdmissions = href.includes('/student-services/admissions/') && currentUrl.startsWith(href);
        const isStudentServices =
            href.includes('/student-services/') &&
            !href.includes('/student-services/admissions/') &&
            currentUrl.startsWith(href) &&
            !currentUrl.includes('/student-services/admissions/');
        const isAbout = href.includes('/about/') && currentUrl.startsWith(href);

        if (
            (isProgram || isBlog || isAdmissions || isStudentServices || isAbout) &&
            !link.classList.contains('fndry-nav-link--active')
        ) {
            link.classList.add('fndry-nav-link--active');
        }
    });
}
